import { teams } from "../../actionTypes";

const initialState = {
  teamsList: [],
};

const teamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case teams.TEAMS_LIST:
      const isData = action.data ? { teamsList: [...action.data] } : null;
      return {
        ...state,
        ...isData,
        isLoading: action.isLoading,
      };
    default:
      return state;
  }
};
export default teamsReducer;
